import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { Check } from 'lucide-react';

import CustomText from '../../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../../store';

import {changeLanguage, getStoredLanguage } from '../../../locales/i18n';

const LanguageSettingsScreen: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	// const languageContext = useContext(LanguageContext)

	// if (!languageContext) return null

	const [language, setLanguage] = useState('')
	// const language = await getStoredLanguage

	const languages = [
		{ code: 'default', name: t('language_setting_screen_message_01') },
		{ code: 'en', name: 'English' },
		{ code: 'ko', name: '한국어' },
		// { code: 'es', name: 'Español' },
		// { code: 'cn', name: '中文' },
		// { code: 'jp', name: '日本語' },
		// { code: 'vn', name: 'Tiếng Việt' }
	]

	useEffect(() => {
		const initLanguage = async () => {
			const lang = await getStoredLanguage()
			setLanguage(lang)
		}
		initLanguage()
	}, [language])

	const selectLanguage = async (langCode: string) => {
		console.log(`선택한 언어 : ${langCode}`)
		changeLanguage(langCode)
		setLanguage(langCode)

		// 변경 언어에 따라 헤더 타이틀 변경
		dispatch(checkHeaderText({ "link": "LanguageSettingsScreen", "title": t('stack_header_message_10') }))
	}

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "LanguageSettingsScreen", "title": t('stack_header_message_10') }))
	}, [])

	const styles = {
		container: {
			padding: "60px 5px 24px",
		} as React.CSSProperties,
		languageOption: {
			display: "flex",
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: "16px 0",
			borderBottom: `1px solid ${theme.border_04}`,
		} as React.CSSProperties,
		languageText: {
			fontSize: 18,
		} as React.CSSProperties,
		sectionTitle: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			padding: "10px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		groupContainer: {
			borderRadius: 10,
			marginVertical: 8,
			overflow: 'hidden',
			width: "100%",
			padding: "0 15px",
			boxSizing: "border-box",
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={{ width: "100%" }}>
				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
					{t('language_setting_screen_message_01')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{languages.slice(0, 1).map((item, index) => (
						<div
							key={item.code}
							style={{
								...styles.languageOption,
								borderColor: theme.divider_background_03,
							}}
							onClick={() => selectLanguage(item.code)}
						>
							<CustomText style={{ ...styles.languageText, color: theme.label_strong }}>
								{item.name}
							</CustomText>
							{language === item.code && <Check name="checkmark" size={20} color={theme.primary_normal} />}
						</div>
					))}
				</div>

				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
				{t('language_setting_screen_message_02')}
				</CustomText>
				<div style={{ 
					...styles.groupContainer, 
					backgroundColor: theme.divider_background_02
				}}>
					{languages.slice(1, 6).map((item, index) => (
						<div
							key={item.code}
							style={{
								...styles.languageOption,
								borderColor: theme.divider_background_03,
							}}
							onClick={() => selectLanguage(item.code)}
						>	
							<CustomText style={{ ...styles.languageText, color: theme.label_strong }}>
								{item.name}
							</CustomText>
							{language === item.code && <Check name="checkmark" size={20} color={theme.primary_normal} />}
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default LanguageSettingsScreen
